export default function valueWasChanged(initialValue: object, value: object): boolean {
  const keys = Object.keys(initialValue);
  let wasChanged = false;
  keys.forEach((key) => {
    if (key !== 'id' && key !== 'created_at' && initialValue[key] !== value[key]) {
      wasChanged = true;
    }
  });
  return wasChanged;
}
